<!-- prettier-ignore -->
<span
  class="subhead color-500"
  *ngIf="date"
  data-test="content-date"
>{{ date | date: 'mediumDate' }} </span>
<span
   class="subhead color-500"
   *ngIf="firstName || lastName"
   data-test="content-author"
   >by {{ firstName }} {{ lastName }}</span
 >
